"use strict";
var $ = require("../internals/export");
var isRegisteredSymbol = require("../internals/symbol-is-registered");
$({ target: "Symbol", stat: true, name: "isRegisteredSymbol" }, {
  isRegistered: isRegisteredSymbol
});
